// extracted by mini-css-extract-plugin
module.exports = {"error-text":"ErrorText_error-text__3j1YT"};